require('../compatible/html2canvas');

export default window.html2canvas;